import { render, staticRenderFns } from "./FullscreenSlider.vue?vue&type=template&id=3031d58e&"
import script from "./FullscreenSlider.vue?vue&type=script&lang=ts&"
export * from "./FullscreenSlider.vue?vue&type=script&lang=ts&"
import style0 from "./FullscreenSlider.vue?vue&type=style&index=0&id=3031d58e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports